import { TipoProtocolloEnum } from "@app/shared/enum/tipo-protocollo-enum";
import { SettoreVO } from "../settoreVO";
import { DocumentoVO } from "../documentoVO";
import { MetadatiProtocolloGescorVO } from "./metadati-protocollo-gescorVO";
import { DestinatarioDTO } from "@app/shared/dto/gescor/destinatarioDTO";
import { DestinatarioInternoDTO } from "@app/shared/dto/gescor/destinatario-internoDTO";
import { DestinatarioDipendenteDTO } from "@app/shared/dto/gescor/destinatario-dipendenteDTO";
import { ClassificaVO } from "../classificaVO";
import { UtenteVO } from "../utenteVO";
import { DestinatarioDipendenteVO } from "./destinatario-dipendenteVO";
import { DestinatarioInternoVO } from "./destinatario-internoVO";
import { DestinatarioVO } from "./destinatarioVO";
import { FormDestinatariVO } from "./form-destinatariVO";
import { UtenteDTO } from "@app/shared/dto/utenteDTO";

export class FormCreaCorrispondenzaPartenzaVO {

   id: string;

   idMittente: string;

   tipoProtocollo: TipoProtocolloEnum;

   mittente: SettoreVO;

   oggetto: string;

   riservata: Boolean;

   primario: DocumentoVO;

   metadatiProtocollo: MetadatiProtocolloGescorVO;

   allegati: DocumentoVO[];

   formDestinatari: FormDestinatariVO = new FormDestinatariVO();

   formDestinatariCartacei: FormDestinatariVO = new FormDestinatariVO();

   destinatariInterni: DestinatarioInternoVO[] = new Array<DestinatarioInternoVO>();

   destinatariDipendenti: DestinatarioDipendenteVO[] = new Array<DestinatarioDipendenteVO>();


   classifica: ClassificaVO[] = new Array<ClassificaVO>();

   //   visibilitaPartenza: VisibilitaPartenzaDTO[];

   firmatario: UtenteVO;

   settoreFirmatario: SettoreVO;

   operatore: UtenteVO;

   numeroAllegati: number;

   descrizioneAllegati: string;

   idUnitaDocumentaria: string;

   //  statoPartenzaEnum: StatoPartenzaEnum;

   //   dataInserimento: string;

   //  datiFirma: DatiFirmaPartenzaDTO;

   //  statoPartenzaProtocollo: StatoPartenzaProtocolloDTO;

   //   richiesteAssociate: boolean;

   //   tipoRichieste: TipoRichiestaEnum[];

}